// sekcja "Poznaj Internal" z statystykami
// @ts-nocheck

import React from 'react';
import classnames from 'classnames';
import { HtmlBlock } from 'components/containers/HtmlBlock';

import styles from 'theme/pages/Home/components/InternalInfo/InternalInfo.module.scss';

export const InternalInfo = () => {
  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Home-components-InternalInfo'
      )}>
      <HtmlBlock
        sectionId="HOMEPAGE_INTERNAL_INFO"
        articleId="HOMEPAGE_INTERNAL_INFO_SECTION"
        hasSeoTitle
      />
    </div>
  );
};

export default InternalInfo;

